import React from "react";
import { Select, Space } from "antd";

export const RoleEdit = ({ roles, allRoles, setRoles }) => {
  const handleChange = (value) => {
    //console.log(`selected ${value}`);
    setRoles(value.map((position) => allRoles[position]));
  };

  const options = allRoles.map((element, index) => ({
    label: element,
    value: `${index}`, // Hier könnte eine eindeutige ID verwendet werden
  }));
  let auswahl = [];
  for (let i = 0; i < allRoles.length; i++) {
    const currentRole = allRoles[i];
    if (roles.includes(currentRole)) {
      auswahl.push("" + i);
      // Das Element ist in beiden Arrays enthalten (gemeinsames Element)
    }
  }
  return (
    <Space 
      style={{
        width: "100%",
      }}
      direction="vertical"
    >
      <Select
        mode="multiple"
        allowClear
        style={{
          width: "100%",
        }}
        placeholder="Wählen Sie die entsprechenden Rollen"
        defaultValue={auswahl}
        onChange={handleChange}
        options={options}
      />
    </Space>
  );
};
